module.exports = __webpack_public_path__ + "img/memberkit.4c4bd80b.svg";